export const getTextColor = (theme) => (theme === "dark" ? "white" : "black");

export const getAsideColor = (theme) => (theme === "dark" ? "pink" : "black");

export const getBorder = (theme) =>
  theme === "dark" ? "1px solid #E7E2F3" : "1px solid black";

export const getBgColor = (theme) => (theme === "dark" ? "black" : "white");
export const getBgColor2 = (theme) =>
  theme === "dark" ? "#4A3780" : "#917FB3";
